class ElementInViewHelper {
    /**
     * @param element
     * @param checkIfCompletelyVisible
     * @param offset
     * @returns {boolean|boolean}
     */
    static isScrolledIntoView(element, checkIfCompletelyVisible = false, offset = 1) {
        const rect = element.getBoundingClientRect();
        const elemTop = rect.top;
        const elemMarginBottom = parseInt(window.getComputedStyle(element).marginBottom, 10);
        const elemBottom = rect.bottom + elemMarginBottom;

        const header = document.querySelector('.page-header');
        const { height: headerHeight } = header.getBoundingClientRect();
        const windowInnerHeight = window.innerHeight;

        let isVisible = elemTop <= windowInnerHeight && elemBottom >= headerHeight;

        if (offset !== 1) {
            isVisible = elemTop < (windowInnerHeight / offset) && elemBottom >= (windowInnerHeight / offset);
        }

        if (checkIfCompletelyVisible) {
            isVisible = (elemTop >= headerHeight) && (elemBottom <= windowInnerHeight);
        }

        return isVisible;
    }
}

export default ElementInViewHelper;
